export default __webpack_public_path__ + "static/media/gournay6.9f70c837.jpg";